<template>
	<div>
		<div
			v-for="workTime in workDaysList"
			:key="'workTime' + workTime.dayOfWeek"
			v-test-id="`workDay-${workTime.dayOfWeek}`"
			class="about-text-val"
		>
			<div>
				<span
					v-if="workTime.day"
					class="week-day"
				>{{ workTime.day }}</span>
				<span
					v-else
					class="week-day"
				>{{ t("weeksDay." + workTime.dayOfWeek) }}</span>
				<span
					v-if="workTime.active"
					class="time"
				>{{ workTime.startTime }} — {{ workTime.endTime }}</span>
				<span
					v-if="!workTime.active"
					class="time"
				>{{ t("dayOff") }}</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import {computed, toRefs, inject} from "vue";
const props = defineProps({
	settings: {
		type: Array,
		default: () => [],
	},
});
const t = inject("t");
const {settings} = toRefs(props);

const workDaysList = computed(() => {
	return [...formateWorkDayList(settings.value.slice(0, 5)), ...formateWorkDayList(settings.value.slice(5))] || [];
});
const formateWorkDayList = (list) => {
	let k = 0;
	for (let i = 0; i < list.length; i++) {
		if (list[i]?.startTime === list[i + 1]?.startTime && list[i].endTime === list[i + 1]?.endTime && list[i].active) {
			k++;
		}
	}
	if (k === list.length - 1) {
		return [{
			day: t("weeksDay." + list[0].dayOfWeek) + "-" + t("weeksDay." + list[list.length - 1].dayOfWeek),
			...list[0],
		}];
	}
	else {
		return list;
	}
};

</script>

<style scoped lang="less">

@import "#app/assets/less/var.less";
.about-text-val {
	font-weight: 600;
	font-size: 14px;
	line-height: 20px;
	color: @color-black;
	@media(min-width: @width--tablet-min) {
		line-height: 20px;
		font-size: 16px;
	}

	.week-day{
		width: 50px;
		display: inline-block;
		margin-right: 16px;
	}
}
</style>
